import { render, staticRenderFns } from "./emergencySuppliesCell.vue?vue&type=template&id=02dc844e&scoped=true&"
import script from "./emergencySuppliesCell.vue?vue&type=script&lang=js&"
export * from "./emergencySuppliesCell.vue?vue&type=script&lang=js&"
import style0 from "./emergencySuppliesCell.vue?vue&type=style&index=0&id=02dc844e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc844e",
  null
  
)

export default component.exports